import { useLocation } from "react-router-dom";

// The "Original" promo preset is a pure read-only overview: no bulk fulfilment
// (ship / lists) and therefore no row selection. ("All" was removed; promo
// defaults to Backorder.)
export default function useReadOnlyPreset(): boolean {
  const { search } = useLocation();
  const preset = new URLSearchParams(search).get("preset");
  return preset === "original";
}
